import { Component, Inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { Router } from "@angular/router";
import { ContractService, SignContractService } from "src/app/core/services/contract.service";
import { PreviewComponent } from "src/app/shared/components/preview/preview.component";
import { MatDialog } from "@angular/material/dialog";
import * as FileSaver from 'file-saver';
import { SystemService } from 'src/app/core/services/system.service';
import { GOOGLE_INV_INFO_MSG } from 'src/app/models/common';
import { AppConfig } from 'src/app/configs/app.config';
import { InsertionOrderService } from 'src/app/core/services/insertion-order.service';
import { downloadFile } from '../utils/commonUtils';
import { ALIService } from 'src/app/core/services/ali.service';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-information-box',
  templateUrl: './information-box.component.html',
  styleUrls: ['./information-box.component.scss']
})
export class InformationBoxComponent implements OnInit {

  file: Blob;
  fileURL: string;

  csvData: Array<any> = [];
  fileName: string = 'conversion_tracker_error'

  popUpSeen: boolean = false;

  supportEmail: string;

  // TODO: Add Austria in this list once ADSP duplicate id for Austria location is fixed.
  countriesToTarget: string[] = ["Bahrain", "Belgium", "Denmark", "France", "Finland", "Germany", "Israel",
                "Italy", "Kuwait", "Luxembourg", "Norway", "Netherlands", "Saudi Arabia", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"]

  contractHistoryDataSource = new MatTableDataSource();
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild(MatSort, {static: false}) set content(sort: MatSort) {
    this.contractHistoryDataSource.sort = sort;
  }
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.contractHistoryDataSource.paginator = mp;
  }

  pageLength: number;

  isUKInstance: boolean = false;
  fileUploaded: boolean = false;
  popUpHeader: string;

  googleInventoryInfoMessage = GOOGLE_INV_INFO_MSG;
  errorURL: string;
  errorMSG: string;
  errorOccured: boolean = false;
  tdspFlightUpdate: string = "new";
  showCancelBtn: Set<string>;
  showSaveBtn: Set<string>;
  showProceedBtn: Set<string>;
  showSnoozeBtn: Set<string>;

  displayedContractColumns: string[] = [
    'serial_number', 'name', 'description', 'msa_type', 'upload_date', 'last_date_to_accept'
  ];
  readonly imgPath: string;
  readonly whiteLabelMode: boolean;
  readonly platformName: string;
  idMapping = {
    'insertion_order': 'io_ids',
    'line_item': 'li_ids',
  }
  minVizLogo: Set<string>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<InformationBoxComponent>,
    private dialog: MatDialog,
    public contractService: ContractService,
    public signContractService: SignContractService,
    public systemService: SystemService,
    private commonService: CommonService,
    private router: Router,
    private insertionOrderService: InsertionOrderService,
    private aliService: ALIService
  ) {
    this.platformName = AppConfig.TITLE;
    this.imgPath = AppConfig.POPUP_LOGO;
    this.whiteLabelMode =  AppConfig.WHITE_LABEL_MODE;
  }

  ngOnInit(): void {
    this.showCancelBtn = new Set([
      "avgBudgetExceeds",
      "flightUpdate",
      "bulkUpload",
      "removeTdspIoFlight",
      "removePixelMapping",
      "bdspPacingChange",
      "expiredLi",
      "expiredIO"
    ]);
    this.showSnoozeBtn = new Set(['pendingContract']);
    this.showSaveBtn = new Set(['flightUpdate', 'bulkUpload']);
    this.showProceedBtn = new Set(['removeTdspIoFlight', 'removePixelMapping', 'bdspPacingChange']);
    this.minVizLogo =  new Set(['productFeedSyncHistory', 'postalCodeValidation'])

    if(this.data.type == 'emailComponent') {
      this.data.email = this.hideEmail(this.data.email);
    }
    else if(this.data.type =='pendingContract') {
      this.getSupportEmail();
      this.pageLength = this.data.items.length;
      this.data.items = this.data.items.map((ele, index) => ele = {...ele, serial_number: index+1})
      this.contractHistoryDataSource = new MatTableDataSource(this.data.items)
      this.updateTable()
    }
    this.dialogRef.updatePosition({
      // top: "20%",
      /** Override for the dialogs bottom position. */
      // left: "35%",
      /** Override for the dialogs right position. */
      // right: "10em",
    });
    this.getPopUpHeading()
  }

  getPopUpHeading() {
    switch (this.data.type) {
      case "countriesToTarget":
        this.popUpHeader = "Countries available for targeting";
        break;
      case "kpiSuggestion":
        this.popUpHeader = "KPI Recommendations";
        break;

      case "tdspFlightUpdates":
        this.popUpHeader = "Bulk Edit - Flights";
        break;

      case "productFeedSyncHistory":
        this.popUpHeader = "Product Feed - Sync History";
        break;
      case "gamblingCtry":
        this.popUpHeader = "List Of Countries";
        break;

      default:
        this.popUpHeader = "ALERT"
    }
  }


  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  onSelectFile(event) {
    this.file = event.target.files && event.target.files[0];
    this.fileUploaded = true;
  }

  getSupportEmail() {
    this.systemService.getInstanceDetails().subscribe((res)=>{
      this.supportEmail = res.support_mail;
    })
  }

  viewFile(id, name, description, can_sign) {
    let params = {};
    params[this.data.clientTypeId] = this.data.clientId;
    this.contractService.viewFile(id, params).subscribe((res)=>{
      this.file = new Blob([res], {type: 'application/pdf'});
      this.fileURL = URL.createObjectURL(this.file);
    }, ()=> {}, ()=>{
      this.previewContractDocument(id, name, description, can_sign);
    })
  }

  objectKeys(obj: object): string[] {
    return Object.keys(obj);
  }

  previewContractDocument(id, name, description, can_sign) {
    this.fileURL += '#toolbar=0'
    let dialogRef = this.dialog.open(PreviewComponent, {
      width: "60%",
      height: "80%",
      disableClose: true,
      autoFocus: false,
      data: { msa_id: id, url: this.fileURL, type:'contract_file', can_sign: can_sign, clientId:this.data.clientId, clientTypeId:this.data.clientTypeId, name: name, description:description},
      panelClass: 'preview-modalbox'
    });
    dialogRef.afterClosed().subscribe((res) => {
      if(res.save) {
        this.getUnsignedContracts();
      }
    })
  }

  getUnsignedContracts() {
    let params = {};
    params[this.data.clientTypeId] = this.data.clientId;
    this.signContractService.list(params).subscribe((res)=> {
      this.data.items = res.data.pending_msa.map((ele) => ele = {...ele, msa_status:'pending'});
      this.pageLength = this.data.items.length
      this.data.overdue = res.data.overdue;
    },() => {},()=>{
      if(this.pageLength > 0) {
        this.data.items = this.data.items.map((ele, index) => ele = {...ele, serial_number: index+1})
        this.contractHistoryDataSource = new MatTableDataSource(this.data.items)
        this.updateTable()
      } else {
        this.popUpSeen = true;
        this.closeModel(true)
      }
    })
  }

  updateTable() {
    this.contractHistoryDataSource = new MatTableDataSource(this.data.items);
    this.contractHistoryDataSource.paginator = this.paginator;
    this.contractHistoryDataSource.sort = this.sort;
    this.contractHistoryDataSource._updatePaginator(this.pageLength);
  }

  hideEmail(email){
    let arr = email.split("@");
    return this.hideWord(arr[0]) + "@" + arr[1];
  }

  hideWord(str) {
    return str.substring(0,2)+"*".repeat(str.length - 4)+str.slice(-2);
  }

  closeModel(saveData: boolean = false) {
    if(this.data.type == 'pendingContract') this.popUpSeen = true;
    if(this.popUpSeen) localStorage.setItem('pendingMSA', 'seen')
    this.dialogRef.close({
      save: saveData,
    });
  }

  exportToCsv(rows: object[], fileName: string, columns?: string[]) {
    const CSV_TYPE = "text/plain;charset=utf-8";
    const CSV_EXTENSION = ".csv";
    const separator = ",";
    let csvContent;
    if (rows.length != 0) {
      let keys = Object.keys(rows[0]).filter((k) => {
        if (columns?.length) {
          return columns.includes(k);
        } else {
          return true;
        }
      });
      keys = keys.map((ele) => {
        return ele;
      });
      csvContent =
        keys.join(separator) +
        "\n" +
        rows
          .map((row) => {
            return keys
              .map((k) => {
                k = k.split(" ")[0];
                let cell =
                  row[k] === null || row[k] === undefined ? "" : row[k];
                cell =
                  cell instanceof Date
                    ? cell.toLocaleString()
                    : cell.toString().replace(/"/g, '""');
                if (cell.search(/("|,|\n)/g) >= 0) {
                  cell = `"${cell}"`;
                }
                return cell;
              })
              .join(separator);
          })
          .join("\n");
    }
    this.saveAsFile(csvContent, `${fileName}${CSV_EXTENSION}`, CSV_TYPE);
  }

  saveAsFile(buffer: any, fileName: string, fileType: string): void {
    const data: Blob = new Blob([buffer], { type: fileType });
    FileSaver.saveAs(data, fileName);
    this.closeModel()
  }

  setDataForCsv() {
    this.csvData = [];
    this.data.ct_err.map((data) => {
      this.csvData.push({
        type: data.type,
        id: data.id,
        reason: data.reason,
      });
    });
  }

  download() {
    this.setDataForCsv();
    let headers = ["type", "id", "reason"];
    this.exportToCsv(this.csvData, this.fileName, headers);
  }

  updateTdspFlight() {
    this.dialogRef.close();
    this.router.navigate([this.data.path], {
        queryParams: { ...this.data.globalParams, mode: this.tdspFlightUpdate, ids: this.data.ids },
      })
  }

  confirmAction() {
    if(this.data.type == 'flightUpdate') {
      this.updateFlightDate()
    } else if (this.data.type == 'bulkUpload') {
      this.uploadEntityItems();
    } else if (this.data.type == 'tdspFlightUpdates') {
      this.updateTdspFlight()
    } else {
      this.closeModel(this.data.type == 'pendingContract' ? false : true);
    }
  }

  getTemplate(type, params = {}) {
    if (type == "multiple") {
      params[this.idMapping[this.data.entityType]] = this.data.items
        .map((ele) => ele.id)
        .join(",");
    }
    params = { ...params, ...this.data.globalParams };
    let service =
      this.data.entityType == "insertion_order"
        ? this.insertionOrderService
        : this.aliService;
    service.getFlightUploadTemplate(params).subscribe((res) => {
      downloadFile(res.download_url);
    });
  }

  getBulkUploadTemplate(params = {}) {
    params = { ...params, ...this.data.globalParams };
    this.insertionOrderService
      .downloadBulkUploadTemplate(params)
      .subscribe((res) => {
        downloadFile(res.download_url);
      });
  }

  uploadEntityItems() {
    let formData: FormData = new FormData();
    formData.append("file", this.file);
    this.errorOccured = false;
    this.insertionOrderService
      .entityBulkUpload(this.data.globalParams, formData)
      .subscribe((res) => {
        if (res.errors) {
          this.errorOccured = true;
          this.errorURL = res.errors.error_report_url;
          this.errorMSG = res.message;
        } else {
          this.dialogRef.close();
          this.commonService.redirectTo(
            this.data.redirectPath,
            this.data.globalParams,
            null
          );
        }
      });
  }

  updateFlightDate() {
    let formData: FormData = new FormData();
    formData.append("file", this.file);
    this.errorOccured = false;
    let service =
      this.data.entityType == "insertion_order"
        ? this.insertionOrderService
        : this.aliService;
    service.uploadFlightsTemplate(this.data.globalParams, formData).subscribe(
      (res) => {
        if (res.errors) {
          this.errorOccured = true;
          this.errorURL = res.errors.error_report_url;
          this.errorMSG = res.message
        } else {
          this.dialogRef.close();
          this.commonService.redirectTo(
            this.data.redirectPath,
            this.data.globalParams,
            null
          );
        }
      },
      (err) => {},
      () => {}
    );
  }

}
